import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { MarketerProduct } from '../../typings/marketers';
import { TextCell } from '../TextCell/TextCell';

const BLOCK = 'marketer-products-cell';

interface MarketerProductsCellProps {
    products: MarketerProduct[];
}

export const MarketerProductsCell = React.memo(function(
    props: MarketerProductsCellProps
) {
    const getText = (): string => {
        const { products } = props;

        return products
            .map(item => `${item.productName} (${item.access})`)
            .join(', ');
    };

    return <TextCell cls={Bem.cls(BLOCK)}>{getText()}</TextCell>;
});
